if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! window.KROWNMinimumOrder ) {

	window.KROWNMinimumOrder = (() => {

		const getBlockedNotice = () => document.querySelector('[data-minimum-order-notice][data-minimum-order-blocked="true"]');

		const isBlocked = () => getBlockedNotice() !== null;

		const showNotice = () => {
			const notice = getBlockedNotice();
			if ( ! notice ) return;

			notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
			notice.focus({ preventScroll: true });

			if ( document.getElementById('screen-reader-info') ) {
				document.getElementById('screen-reader-info').innerText = notice.textContent.trim();
			}
		};

		const disableBlockedCheckoutButtons = () => {
			if ( ! isBlocked() ) return;

			document.querySelectorAll('[data-minimum-order-checkout]').forEach(button => {
				button.disabled = true;
				button.setAttribute('aria-disabled', 'true');
			});
		};

		document.addEventListener('submit', e => {
			const submitter = e.submitter || document.activeElement;
			const isCheckoutSubmit = submitter?.matches?.('[data-minimum-order-checkout], button[name="checkout"], input[name="checkout"]');

			if ( isCheckoutSubmit && isBlocked() ) {
				e.preventDefault();
				e.stopImmediatePropagation();
				showNotice();
			}
		}, true);

		document.addEventListener('click', e => {
			const checkoutTrigger = e.target.closest('[data-minimum-order-checkout], button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');

			if ( checkoutTrigger && isBlocked() ) {
				e.preventDefault();
				e.stopImmediatePropagation();
				showNotice();
			}
		}, true);

		new MutationObserver(disableBlockedCheckoutButtons).observe(document.body, {
			attributes: false,
			childList: true,
			subtree: true
		});

		disableBlockedCheckoutButtons();

		return {
			isBlocked,
			showNotice,
			disableBlockedCheckoutButtons
		};

	})();

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}

document.addEventListener('change', function(e) {
  if (e.target.name === 'attributes[_Require Compliance Labels]') {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          "_Require Compliance Labels": e.target.checked ? "Yes" : ""
        }
      })
    });
  }
});

if ( ! window.StatesideWeeklyOfferGifts ) {

	window.StatesideWeeklyOfferGifts = (() => {

		const config = {
			threshold: 35000,
			startsAt: '2026-10-04T23:00:00Z',
			endsAt: '2026-10-11T23:00:00Z',
			propertyKey: '_weekly_offer',
			propertyValue: 'week-1-lays-stax',
			gifts: [
				{ id: 46130705694860 },
				{ id: 46130707792012 }
			]
		};

		const giftVariantIds = config.gifts.map(gift => String(gift.id));
		let syncing = false;
		let syncQueued = false;
		let syncTimer = null;
		let originalFetch = null;

		const isActive = () => {
			const now = Date.now();
			return now >= Date.parse(config.startsAt) && now < Date.parse(config.endsAt);
		};

		const isOfferGiftLine = item => {
			return giftVariantIds.includes(String(item.variant_id))
				&& item.properties
				&& item.properties[config.propertyKey] === config.propertyValue;
		};

		const getQualifyingTotal = cart => {
			return cart.items.reduce((total, item) => {
				return isOfferGiftLine(item) ? total : total + item.final_line_price;
			}, 0);
		};

		const cartRequest = (url, body) => {
			return (originalFetch || fetch)(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify(body)
			}).then(response => {
				if ( response.ok ) {
					return response.json();
				}
				return response.json().catch(() => ({})).then(error => Promise.reject(error));
			});
		};

		const fetchCart = () => {
			return (originalFetch || fetch)('/cart.js', {
				headers: { 'Accept': 'application/json' }
			}).then(response => response.json());
		};

		const areOfferGiftsDiscounted = cart => {
			return config.gifts.every(gift => {
				return cart.items.some(item => {
					return String(item.variant_id) === String(gift.id)
						&& isOfferGiftLine(item)
						&& (item.final_line_price === 0 || (item.discounts && item.discounts.length > 0));
				});
			});
		};

		const waitForDiscountedGifts = async () => {
			for ( let attempt = 0; attempt < 6; attempt++ ) {
				const cart = await fetchCart();
				if ( areOfferGiftsDiscounted(cart) ) {
					return;
				}
				await new Promise(resolve => window.setTimeout(resolve, 250));
			}
		};

		const refreshCartDisplay = () => {
			if ( typeof window.refreshCart === 'function' ) {
				window.refreshCart();
			} else {
				document.dispatchEvent(new Event('cart-updated'));
			}
		};

		const removeOfferGiftLines = async cart => {
			let changed = false;
			for ( const item of cart.items ) {
				if ( isOfferGiftLine(item) ) {
					await cartRequest('/cart/change.js', { id: item.key, quantity: 0 });
					changed = true;
				}
			}
			return changed;
		};

		const sync = async () => {
			if ( syncing ) {
				syncQueued = true;
				return;
			}

			syncing = true;

			try {
				const cart = await fetchCart();

				if ( ! isActive() || getQualifyingTotal(cart) < config.threshold ) {
					if ( await removeOfferGiftLines(cart) ) {
						refreshCartDisplay();
					}
					return;
				}

				let changed = false;
				let addedGifts = false;
				const itemsToAdd = [];

				for ( const item of cart.items ) {
					if ( isOfferGiftLine(item) && ! giftVariantIds.includes(String(item.variant_id)) ) {
						await cartRequest('/cart/change.js', { id: item.key, quantity: 0 });
						changed = true;
					}
				}

				for ( const gift of config.gifts ) {
					const giftLines = cart.items.filter(item => {
						return String(item.variant_id) === String(gift.id) && isOfferGiftLine(item);
					});
					const giftQuantity = giftLines.reduce((quantity, item) => quantity + item.quantity, 0);

					if ( giftQuantity === 0 ) {
						itemsToAdd.push({
							id: gift.id,
							quantity: 1,
							properties: {
								[config.propertyKey]: config.propertyValue
							}
						});
						continue;
					}

					if ( giftLines[0].quantity !== 1 ) {
						await cartRequest('/cart/change.js', { id: giftLines[0].key, quantity: 1 });
						changed = true;
					}

					for ( const extraLine of giftLines.slice(1) ) {
						await cartRequest('/cart/change.js', { id: extraLine.key, quantity: 0 });
						changed = true;
					}
				}

				if ( itemsToAdd.length > 0 ) {
					await cartRequest('/cart/add.js', { items: itemsToAdd });
					changed = true;
					addedGifts = true;
				}

				if ( changed ) {
					if ( addedGifts ) {
						await waitForDiscountedGifts();
					}
					refreshCartDisplay();
				}
			} catch (error) {
				console.warn('Weekly offer gift sync failed', error);
			} finally {
				syncing = false;
				if ( syncQueued ) {
					syncQueued = false;
					window.setTimeout(sync, 25);
				}
			}
		};

		const queueSync = delay => {
			window.clearTimeout(syncTimer);
			syncTimer = window.setTimeout(sync, delay || 0);
		};

		const isCartMutationUrl = url => {
			if ( ! url ) {
				return false;
			}
			try {
				return /\/cart\/(add|change|update)\.js$/.test(new URL(url, window.location.origin).pathname);
			} catch (error) {
				return /\/cart\/(add|change|update)\.js(?:\?|$)/.test(String(url));
			}
		};

		const queueCartMutationSync = () => {
			queueSync();
			window.setTimeout(() => queueSync(), 350);
			window.setTimeout(() => queueSync(), 1200);
		};

		const observeCartChanges = () => {
			document.querySelectorAll('#AjaxCartForm, #AjaxCartSubtotal').forEach(element => {
				if ( element.statesideWeeklyOfferObserved ) {
					return;
				}
				element.statesideWeeklyOfferObserved = true;
				new MutationObserver(() => queueSync(50)).observe(element, {
					childList: true,
					characterData: true,
					subtree: true
				});
			});
		};

		if ( window.fetch && ! window.fetch.statesideWeeklyOfferWrapped ) {
			originalFetch = window.fetch.bind(window);
			const wrappedFetch = (...args) => {
				const response = originalFetch(...args);
				const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;
				if ( isCartMutationUrl(requestUrl) ) {
					response.then(response => {
						if ( response.ok ) {
							queueCartMutationSync();
						}
					}).catch(() => {});
				}
				return response;
			};
			wrappedFetch.statesideWeeklyOfferWrapped = true;
			window.fetch = wrappedFetch;
		}

		if ( window.XMLHttpRequest && ! window.XMLHttpRequest.prototype.statesideWeeklyOfferWrapped ) {
			const originalOpen = window.XMLHttpRequest.prototype.open;
			const originalSend = window.XMLHttpRequest.prototype.send;
			window.XMLHttpRequest.prototype.open = function(method, url, ...args) {
				this.statesideWeeklyOfferUrl = url;
				return originalOpen.call(this, method, url, ...args);
			};
			window.XMLHttpRequest.prototype.send = function(...args) {
				this.addEventListener('loadend', () => {
					if ( this.status >= 200 && this.status < 400 && isCartMutationUrl(this.statesideWeeklyOfferUrl) ) {
						queueCartMutationSync();
					}
				});
				return originalSend.apply(this, args);
			};
			window.XMLHttpRequest.prototype.statesideWeeklyOfferWrapped = true;
		}

		document.addEventListener('cart-updated', () => {
			observeCartChanges();
			queueCartMutationSync();
		}, true);
		document.addEventListener('DOMContentLoaded', () => {
			observeCartChanges();
			sync();
		});
		window.addEventListener('pageshow', () => {
			observeCartChanges();
			sync();
		});
		observeCartChanges();
		queueSync();

		return { sync };

	})();

}